import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
  
  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation AppCreateMutation($input: CreateAppTInput!) {
    createAppT(input: $input) {
      appT {
        appId
        accountId
        appStatus
        appName
        appSku
        appUrl
        signupUrl
        appLogo
        description
        appType
        parentAppId
        oemAppId
        atId
        appSkuPrice
        appMarkupAbsolute
        appMarkupPercentage
        jitFloatDefault
        marqetaMid
        marqetaMname
        maxCharge
        paymentOrder
        passThroughFees
        wholesaleDiscountPercentage
        billingFrequency
        showDomain
        showUsername
      }
    }
  }
  `;

  function commit(accountId, appStatus, appName,
                  appSku, appUrl, signupUrl, appLogo, description, appType,
                  parentAppId, oemAppId, atId, 
                  appSkuPrice, appMarkupAbsolute, appMarkupPercentage, jitFloatDefault,
                  marqetaMid, marqetaMname, maxCharge, paymentOrder, passThroughFees, wholesaleDiscountPercentage, billingFrequency, showDomain, showUsername) {
    const variables = {
      input: {
        appT: {
          "accountId": accountId,
          "appStatus": appStatus,
          "appName": appName,
          "appSku": appSku,
          "appUrl": appUrl,
          "signupUrl": signupUrl,
          "appLogo": appLogo,
          "description": description,
          "appType": appType,
          "parentAppId": parentAppId,
          "oemAppId": oemAppId,
          "atId": atId,
          "appSkuPrice": appSkuPrice,
          "appMarkupAbsolute": appMarkupAbsolute,
          "appMarkupPercentage": appMarkupPercentage,
          "jitFloatDefault": jitFloatDefault,
          "marqetaMid": marqetaMid,
          "marqetaMname": marqetaMname,
          "maxCharge": maxCharge,
          "paymentOrder": paymentOrder,
          "passThroughFees": passThroughFees,
          "wholesaleDiscountPercentage": wholesaleDiscountPercentage,
          "billingFrequency": billingFrequency,
          "showDomain": showDomain,
          "showUsername": showUsername
        }
      }
    }
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            reject(error);
          }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  